import { useTranslation } from 'next-i18next';
import {useRouter} from 'next/router'

export default function CartSteps() {
  const router = useRouter();
  const {locale} = useRouter();
  const {t} = useTranslation('cart');
  const ClassApplier = (tab: number) => {
    if ((true) && tab == 1) {
      return true
    }
    if (
      (router.asPath == '/cart/address' || router.asPath == '/cart/address#') &&
      tab == 1
    ) {
      return true
    }
    if (
      (router.asPath == '/cart/address' || router.asPath == '/cart/address#') &&
      tab == 2
    ) {
      return true
    }
    if (
      (router.asPath == '/cart/payment' || router.asPath == '/cart/payment#') &&
      tab == 1
    ) {
      return true
    }
    if (
      (router.asPath == '/cart/payment' || router.asPath == '/cart/payment#') &&
      tab == 2
    ) {
      return true
    }
    if (
      (router.asPath == '/cart/payment' || router.asPath == '/cart/payment#') &&
      tab == 3
    ) {
      return true
    }

    //if (
    //router.asPath == '/cart/payment' ||
    //(router.asPath == '/cart/payment#' && tab == 3)
    //) {
    //return true
    //}
    return false
  }
  return (
    <div className="cart-steps  bg-white w-full pb-3 pt-3 lg:py-4 px-2 lg:px-4 mb-2 lg:mb-4 rounded-md text-center">
      <div className="cart-steps-inner grid grid-cols-3 lg:flex items-center justify-center" dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}>
        <div className={`cart-step ${locale === 'ar' ? '' : 'mr-4'}`}>
          <p
            className={`text-[12px] sm:text-sm lg:text-base ${
              ClassApplier(1) ? 'text-success-200' : 'text-gray-200'
            } mb-2`}>
            {t('cart')}
          </p>
          <strong
            className={`block h-1 w-full lg:w-[200px] ${
              ClassApplier(1) ? 'bg-success-500' : 'bg-gray-200'
            } rounded-md`}></strong>
        </div>

        <div className="cart-step mr-4">
          <p
            className={`text-[12px] sm:text-sm lg:text-base ${
              ClassApplier(2) ? 'text-success-500' : 'text-gray-200'
            } mb-2`}>
            {t('addressSelection')}
          </p>
          <strong
            className={`block h-1 w-full lg:w-[200px] ${
              ClassApplier(2) ? 'bg-success-500' : 'bg-gray-200'
            } rounded-md`}></strong>
        </div>

        <div className="cart-step mr-4">
          <p
            className={`text-[12px] sm:text-sm lg:text-base ${
              ClassApplier(3) ? 'text-success-500' : 'text-gray-200'
            } mb-2`}>
            {t('payment')}
          </p>
          <strong
            className={`block h-1 w-full lg:w-[200px] ${
              ClassApplier(3) ? 'bg-success-500' : 'bg-gray-200'
            } rounded-md`}></strong>
        </div>
      </div>
    </div>
  )
}
